import { connect } from 'react-redux'
import { makeConditionSelector } from 'selectors/feature/conditions'
import { makeConditionSimulationSelector } from 'selectors/feature/simulation'

import SingleConditionSimulator from './SingleConditionSimulator'

const makeMapStateToProps = () => {
  const conditionSelector = makeConditionSelector()
  const simulationSelector = makeConditionSimulationSelector()
  const mapStateToProps = (state, ownProps) => {
    const { uri } = ownProps
    const condition = conditionSelector(state, { queryUri: uri })
    const simulation = simulationSelector(state, { queryUri: uri })

    return {
      ...ownProps,
      ...condition,
      ...simulation,
    }
  }

  return mapStateToProps
}

export default connect(makeMapStateToProps)(SingleConditionSimulator)
